export default {
  permissionsByRole: (state) => state.permissionList,
};
